import React, { useContext, useMemo, useState } from 'react';
import { CompanyRoleAssignmentContext } from '../../../../context/CompanyRoleAssignmentContext';
import { TagContext } from '../../../../context/TagContext';
import { entityTypeToString } from '../../../../types/comment';
import { Tag } from '../../../../types/tag/tag';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { TagFilter } from '../../../../VentoryUI/components/filters/TagFilter';
import { CreateButton } from '../../../components/Button';
import { SearchFilter } from '../../../components/Filter';
import Table from '../../../components/Table';
import { DeleteIconButton } from '../../../icons';
import DeleteTagModal from './DeleteTagModal';
import TagModal from './TagModal';

interface ModalProps {
  tag: Tag | undefined;
  open: boolean;
}

export default function TagSettingsScreen() {
  const { tags } = useContext(TagContext);
  const { isAdmin } = useContext(CompanyRoleAssignmentContext);

  const allItems = useMemo(() => {
    return [...tags.values()];
  }, [tags]);

  const [items, setItems] = useState(allItems);

  const [modalProps, setModalProps] = useState<ModalProps>({ tag: undefined, open: false });
  const [deleteTag, setDeleteTag] = useState<Tag | undefined>(undefined);

  const filter = new TagFilter(undefined);

  return (
    <>
      {modalProps.open && (
        <TagModal
          open={modalProps.open}
          setOpen={open => setModalProps({ ...modalProps, open })}
          tag={modalProps.tag}
        />
      )}
      {deleteTag && <DeleteTagModal open={true} setOpen={open => !open && setDeleteTag(undefined)} tag={deleteTag} />}

      <div className='content-x content-y-screen flex h-full flex-grow flex-col gap-8'>
        <div className='grid gap-2'>
          <p className='page-title'>{t(TranslationKey.tagSettingsScreenTitle).singular.upper}</p>
          <p className='subtitle'>{t(TranslationKey.tagSettingsScreenSubtitle).singular.upper}</p>
        </div>

        <div className='flex flex-grow flex-col gap-4'>
          <div className='flex justify-between gap-4'>
            <SearchFilter filter={filter} items={allItems} setItems={setItems} />
            {isAdmin && <CreateButton onClick={() => setModalProps({ open: true, tag: undefined })} />}
          </div>
          <Table
            items={items}
            filter={filter}
            onClick={tag => setModalProps({ open: true, tag })}
            headers={[
              {
                key: 'name',
                name: t(TranslationKey.name).singular.label,
                text: (item: Tag) => item.name,
              },
              {
                key: 'type',
                name: t(TranslationKey.type).singular.label,
                text: (item: Tag) => entityTypeToString(item.type),
              },
              {
                key: 'delete',
                name: '',
                text: (item: Tag) => <DeleteIconButton onClick={() => setDeleteTag(item)} />,
              },
            ]}
          />
        </div>
      </div>
    </>
  );
}
